import rp1010 from "./rp1010";
export default {rp1010,
};